// components/Header.jsx
import { useState , useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, useScroll, useMotionValueEvent, color } from "framer-motion";
import {  FaBars, FaTimes } from "react-icons/fa";

const Header = () => {

const tweppleTextColor = [
  "#FF5A3C", // T
  "#1EC8B3", // w
  "#4CAF50", // e
  "#8E44AD", // p
  "#FF6FAF", // p
  "#3A86FF", // l
  "#FFC83D", // e
];

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const { scrollY } = useScroll();



  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useMotionValueEvent(scrollY, "change", (latest) => {
    setIsScrolled(latest > 50);
  });

  const handleLogoClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Games", path: "/games" },
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
    { name: "Careers", path: "/careers" },
    { name: "Blog", path: "/blog" },
  ];

  return (
    <motion.header
      className={`fixed w-full top-0 z-50 flex items-center justify-between 
px-4 md:px-8 xl:px-12 py-4 transition-all duration-300
${isScrolled ? "bg-[#F3ECE5] shadow-lg backdrop-blur-sm" : "bg-transparent"}
`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* Logo */}
      <Link
        to="/"
        className="flex items-center gap-1 select-none"
        onClick={handleLogoClick}
      >
        <span className="flex text-3xl md:text-3xl font-baloo font-bold ">
          {"Twepple".split("").map((char, i) => (
            <span key={i} style={{ color: tweppleTextColor[i] }}>
              {char}
            </span>
          ))}
        </span>
      </Link>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center gap-10  text-lg font-baloo  font-bold">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.name}
              to={item.path}
              className={`relative pb-1 transition-colors 
          ${
            isActive
              ? "text-[#2F3E5C] font-semibold"
              : "text-[#2F3E5C] hover:text-[#4F46E5]"
          }`}
            >
              {item.name}

              {isActive && (
                <motion.div
                  layoutId="header-underline"
                  className="absolute -left-2 -right-2 -bottom-1 h-[3px] bg-[#4F46E5] rounded-full"
                />
              )}
            </Link>
          );
        })}
      </nav>

      {/* Mobile Menu Button */}
      <button
        className="md:hidden bg-white shadow-lg rounded-xl p-3 flex items-center justify-center"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        {isMenuOpen ? (
          <FaTimes className="text-xl text-[#2F3E5C]" />
        ) : (
          <FaBars className="text-xl text-[#2F3E5C]" />
        )}
      </button>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <motion.nav
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="absolute top-full left-2 right-2 bg-white shadow-xl py-6 md:hidden rounded-xl"
        >
          {navItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className={`block px-6 py-3 text-lg  text-[#2F3E5C] hover:bg-gray-100 ${
                location.pathname === item.path
                  ? "font-baloo font-extrabold text-[#0e1a31]"
                  : "font-baloo font-semibold"
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              {item.name}
            </Link>
          ))}
        </motion.nav>
      )}
    </motion.header>
    // <motion.header
    //   className={`fixed w-full py-4 px-6 flex justify-between items-center z-50 transition-colors duration-300 ${
    //     isScrolled ? "bg-gray-900/95 backdrop-blur-lg" : "bg-transparent"
    //   }`}
    //   initial={{ y: -100 }}
    //   animate={{ y: 0 }}
    //   transition={{ duration: 0.5 }}
    // >
    //   <Link
    //     to="/"
    //     className="flex items-center gap-2 group"
    //     onClick={handleLogoClick}
    //   >
    //     <motion.div whileHover={{ rotate: 360 }} transition={{ duration: 0.8 }}>
    //       <FaGamepad className="text-3xl text-cyan-400" />
    //     </motion.div>
    //     <span className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">
    //       Twepple
    //     </span>
    //   </Link>

    //   {/* Desktop Navigation */}
    //   <nav className="hidden md:flex space-x-6">
    //     {navItems.map((item) => (
    //       <Link
    //         key={item.name}
    //         to={item.path}
    //         className={`relative px-4 py-2 text-gray-100 hover:text-cyan-400 transition-colors ${
    //           location.pathname === item.path ? "text-cyan-400" : ""
    //         }`}
    //       >
    //         {item.name}
    //         {location.pathname === item.path && (
    //           <motion.div
    //             className="absolute bottom-0 left-0 right-0 h-0.5 bg-cyan-400"
    //             layoutId="header-underline"
    //           />
    //         )}
    //       </Link>
    //     ))}
    //   </nav>

    //   {/* Mobile Menu Button */}
    //   <button
    //     className="md:hidden text-2xl text-gray-300 hover:text-cyan-400 transition-colors"
    //     onClick={() => setIsMenuOpen(!isMenuOpen)}
    //   >
    //     {isMenuOpen ? <FaTimes /> : <FaBars />}
    //   </button>

    //   {/* Mobile Menu */}
    //   {isMenuOpen && (
    //     <motion.nav
    //       initial={{ opacity: 0, y: -20 }}
    //       animate={{ opacity: 1, y: 0 }}
    //       className="md:hidden absolute top-full left-0 right-0 bg-gray-900/95 backdrop-blur-lg py-4"
    //     >
    //       {navItems.map((item) => (
    //         <Link
    //           key={item.name}
    //           to={item.path}
    //           className={`block px-6 py-3 text-gray-300 hover:text-cyan-400 hover:bg-gray-800/50 ${
    //             location.pathname === item.path
    //               ? "text-cyan-400 bg-gray-800/50"
    //               : ""
    //           }`}
    //           onClick={() => setIsMenuOpen(false)}
    //         >
    //           {item.name}
    //         </Link>
    //       ))}
    //     </motion.nav>
    //   )}
    // </motion.header>
  );
};

export default Header;
